import { render, staticRenderFns } from "./accessRecordView.vue?vue&type=template&id=f1419b0e"
import script from "./accessRecordView.vue?vue&type=script&lang=js"
export * from "./accessRecordView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports